export const PORTFOLIO_UID = "GDlai5dHijSaKcUW2R9xsGcS6Cn1";

export const FEATURED_LINKS = {
  substack: "https://imprashantrai1.substack.com/",
  booking:
    "https://outlook.office.com/bookwithme/user/4473acf47fe14c3f961039b589460f5f@tuni.fi/meetingtype/wK8GzHaXiUeWawGJq468xw2?anonymous&ismsaljsauthenabled&ep=mLinkFromTile",
  currentProject:
    "https://www.tuni.fi/en/research/sencan-sensor-calibrations-anywhere",
};

export const DEFAULT_ABOUT_BLURBS = [
  "I build across research, products, and storytelling. This site is where I keep the threads together.",
  "My work usually sits at the intersection of ideas, execution, and communication: papers, talks, videos, and the projects behind them.",
  "I care about clear thinking, useful tools, and making complex topics easier to understand for the right audience.",
];

export const FALLBACK_PROFILE_IMAGE = "/images/profile-pic.png";
export const FALLBACK_LOGO = "/images/sign.png";
export const FALLBACK_ABOUT_IMAGE = "/images/chibi.jpeg";
